import { defineStore } from 'pinia'
// @ts-ignore
import { ref, computed } from 'vue'
import type { Project } from '@/types'

export const useProjectStore = defineStore('project', () => {
  // State
  const currentProject = ref<Project | null>(null)

  // Getters
  const getCurrentProject = computed(() => currentProject.value)
  const getCurrentProjectName = computed(() => 
    currentProject.value ? currentProject.value.name : null
  )

  // Actions
  function setCurrentProject(project: Project | null) {
    currentProject.value = project
  }

  function clearCurrentProject() {
    currentProject.value = null
  }

  return {
    // State
    currentProject,
    
    // Getters
    getCurrentProject,
    getCurrentProjectName,
    
    // Actions
    setCurrentProject,
    clearCurrentProject
  }
})